// tslint:disable-next-line:max-line-length
export const phoneInputMask: Array<string | RegExp> = ['+', '7', ' ', '(', /\d/, /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, '-', /\d/, /\d/, '-', /\d/, /\d/];
